import React from 'react';
import NursingCareCatalogManager from '../../head-doctor/nursing/NursingCareCatalogManager';
import nursingInjectionCatalogService from '../../../services/nursingInjectionCatalogService';
import { MAJOR_COPY } from '../majorCopy';

export default function MajorInjectionPage() {
  return (
    <NursingCareCatalogManager
      copy={MAJOR_COPY.NURSING_INJECTION_CATALOG}
      service={nursingInjectionCatalogService}
    />
  );
}
